import axios from "axios";
import {
    API_MAKE_LIST_COMPANY_URI,
    API_LIST_COMPANY_TRANSACTION_URI,
    API_MAKE_LIST_COMPANY_USERS_URI
} from "../constants/api.constant";
import {CompanyResponse, Pagination, CompanyTransaction, CompanyMember, CreateUserRequest} from "../types";
import {QueryString} from "../utils/Querystring";

export default class CompanyService {
    static async list(ownerCorId: string): Promise<CompanyResponse[]> {
        return await axios.get(API_MAKE_LIST_COMPANY_URI(ownerCorId))
            .then(response => response.data)
            .catch(e => Promise.reject(e?.data || e));
    }


    static async users(companyId: string): Promise<{pending_invitations: CompanyMember[], existing_members: CompanyMember[]}> {
        return await axios.get(API_MAKE_LIST_COMPANY_USERS_URI(companyId))
            .then(response => response.data)
            .catch(e => Promise.reject(e?.data || e));
    }
    static async transaction(params: any): Promise<Pagination<CompanyTransaction>> {
        return await axios.get(API_LIST_COMPANY_TRANSACTION_URI, {
            params,
            paramsSerializer: params => {
                return QueryString.stringify({
                    ...params,
                });
            },
        })
            .then(response => response.data)
            .catch(e => Promise.reject(e?.data || e));
    }
}

